import { render, staticRenderFns } from "./salesStatistics.vue?vue&type=template&id=8c2ed01e&scoped=true"
import script from "./salesStatistics.vue?vue&type=script&lang=js"
export * from "./salesStatistics.vue?vue&type=script&lang=js"
import style0 from "./salesStatistics.vue?vue&type=style&index=0&id=8c2ed01e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2ed01e",
  null
  
)

export default component.exports